import Vue from "vue";
import axios from "axios";

export default {
  state: {
    isAdmin: localStorage.getItem("isAdmin") || false,
    logged: false,
    token: localStorage.getItem("token") || "",
    user: localStorage.getItem("user") || {},
    users: []
  },
  mutations: {
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setLogged(state, data) {
      state.logged = data.logged;
      state.user = data.user;
    },
    setToken(state, token) {
      state.token = token.slice();
      localStorage.setItem("token", token.slice());
    },
    setUser(state, data) {
      state.user = data;
      state.logged = true;
    },
    setUsers(state, users) {
      state.users = users.slice();
    },
    logOut() {
      localStorage.removeItem("isAdmin");
      localStorage.removeItem("logged");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  },
  actions: {
    checkToken(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/check_token`)
          .then(r => {
            ctx.commit("setLogged", {
              logged: true,
              user: r.data.email
            });
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    logIn(ctx, payload) {
      return new Promise((resolve, reject) => {
        const request = {
          email: payload.email,
          password: payload.password,
          remember: true
        };
        axios
          .post(`/login`, request)
          .then(rLogin => {
            ctx.commit("setToken", rLogin.data.token);
            ctx.commit("setUser", request.email);
            localStorage.setItem("logged", true);
            localStorage.setItem("user", JSON.stringify(request.email));
            resolve();
          })
          .catch(error => {
            localStorage.setItem("logged", false);
            reject(error);
          });
      });
    },
    isAdmin(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get("/is_admin")
          .then(r => {
            const is_admin = r.data.is_admin;
            ctx.commit("setIsAdmin", is_admin);
            localStorage.setItem("isAdmin", is_admin);
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchUsers(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users`)
          .then(r => {
            ctx.commit("setUsers", r.data.users);
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    getIsAdmin(state) {
      return state.isAdmin;
    },
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    getLogged(state) {
      return state.logged;
    },
    getUsers(state) {
      return state.users;
    }
  }
};
